import React from 'react'

import * as Dialog from '@radix-ui/react-dialog'

import { useScanMutation } from '../../../redux/services/morning-scan'
import CloseIcon from '../../../vectors/CloseIcon'

export interface ScanResultModalProps {
  children: React.ReactNode
}

export const ScanResultModal: React.FC<ScanResultModalProps> = ({
  children,
}) => {
  const [, { data, error, reset }] = useScanMutation({
    fixedCacheKey: 'scan',
  })

  return (
    <Dialog.Root open={Boolean(data || error)} modal={false}>
      <Dialog.Portal>
        <Dialog.Overlay
          onClick={reset}
          className="bg-indigo-scrim fixed inset-0 opacity-60 transition-colors"
        />
        <Dialog.Content className="animate-fade-up shadow-elevation-2 fixed inset-0 m-auto h-fit w-fit rounded-md">
          <Dialog.Close
            onClick={reset}
            className="hover:bg-gray-34 absolute right-4 top-4 outline-1 focus:outline-indigo-50"
          >
            <CloseIcon />
          </Dialog.Close>

          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default ScanResultModalProps
